const PictureIcon = ({
    color = '#000',
    fondo = '#fff',
    vetor_css = { fontSize: '50px' },
    main_css = { width: '40px', padding: '0px' }
}) => {

    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" style={main_css} viewBox="0 0 160.000000 120.000000">
            <g transform="translate(0.000000,120.000000) scale(0.100000,-0.100000)"
                fill={color} stroke="none">
                <path d="M95 1186 c-40 -18 -73 -56 -85 -97 -6 -20 -10 -226 -10 -498 0 -449
                    1 -466 21 -507 15 -31 32 -48 63 -64 43 -20 52 -20 729 -18 675 3 686 3 713
                    24 15 11 37 33 48 48 21 27 21 38 21 526 0 488 0 499 -21 526 -11 15 -33 37
                    -48 48 -27 21 -38 21 -714 23 -558 2 -693 0 -717 -11z m321 -175 c123 -56 148
                    -199 50 -289 -74 -68 -168 -66 -239 5 -57 56 -70 120 -38 188 46 99 137 137
                    227 96z m837 -312 l147 -141 0 -179 0 -179 -600 0 -600 0 0 78 0 78 118 117
                    c66 64 123 117 129 117 5 0 53 -41 107 -92 l97 -91 218 216 c119 120 222 217
                    228 217 5 0 76 -63 156 -141z"/>
            </g>
        </svg>
    )
}

export default PictureIcon;

